import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import {googleLogout} from "@react-oauth/google";
import URLS from "../../API/Axios/URLS";
import {DAILY_PRACTICE_LIMIT} from "../../settings/settings";
import {useMemberShipModal} from "./buy-membership-slice";

const initialState = {
    token: null,
    profile: {
        name: null,
        email: null,
        phone: null,
        address: null,
        dp_uri: {
            id: null,
            file: null,
        },
        date_joined: null,
        referral_code: null,
        member_ship: {
            plan: {
                package: {

                    has_book: null,
                }
            },
            total_today_practiced: null,
            is_active: null,
        }
    }
}

export const AUTH_ACTIONS = {
    CLEAR_SESSION: "CLEAR_SESSION",
    SET_SESSION: "SET_SESSION",
    UPDATE_SESSION: "UPDATE_SESSION",
}


const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_ACTIONS.CLEAR_SESSION:
            return initialState;
        case AUTH_ACTIONS.SET_SESSION:
            return {
                ...action.payload
            }
        case AUTH_ACTIONS.UPDATE_SESSION:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state;
    }
}
let last_fetched = null;

export function useSession() {
    const dispatch = useDispatch();
    const session = useSelector(state => state.AuthReducer);
    const SESSION_STORAGE_KEY = "DET_STUDY_LOGIN_SESSION";
    const [isOpen, actionsMembership] = useMemberShipModal();

    const clearSession = () => {
        axiosInstance.defaults.headers['Authorization'] = null;
        localStorage.removeItem(SESSION_STORAGE_KEY);
        dispatch({type: AUTH_ACTIONS.CLEAR_SESSION})
        googleLogout();
    }
    const setSession = (payload, save_in_storage = true) => {
        if (save_in_storage) localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(payload));
        axiosInstance.defaults.headers['Authorization'] = `token ${payload.token}`;
        dispatch({type: AUTH_ACTIONS.SET_SESSION, payload: payload})
    }
    const updateSession = (payload) => {
        localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(payload));
        dispatch({type: AUTH_ACTIONS.UPDATE_SESSION, payload: payload})
    }
    const isUserAuthenticated = () => {
        return session.token !== null;
    }

    const loadSession = async () => {
        let session = await localStorage.getItem(SESSION_STORAGE_KEY);
        if (session === null) return;
        session = JSON.parse(session);
        axiosInstance.defaults.headers['Authorization'] = `token ${session.token}`;
        dispatch({type: AUTH_ACTIONS.SET_SESSION, payload: session})
    }

    async function refreshPackage() {
        await axiosInstance.get(URLS.packageInfo).then(response => {
            updateSession({
                ...session,
                profile: {
                    ...session.profile,
                    member_ship: response.data?.data
                }
            })
            last_fetched = new Date();
        })
    }

    function is_admin() {
        return session?.profile?.is_staff;
    }

    function hasActiveSubscription() {
        // if (last_fetched === null || lastFetchedIsMoreThen10Minutes())
        //     await refreshPackage();
        return session?.profile?.member_ship?.is_active || session?.profile?.is_staff;
    }

    function hasBook() {
        return session?.profile?.member_ship?.plan?.package?.has_book;
    }

    function hasDailyLimit() {
        return session?.profile?.member_ship?.total_today_practiced <= DAILY_PRACTICE_LIMIT;
    }

    function lastFetchedIsMoreThen10Minutes() {
        return last_fetched === null || new Date() - last_fetched > 1000 * 60 * 10;
    }

    async function allowedToPractice() {
        if (last_fetched === null || lastFetchedIsMoreThen10Minutes())
            await refreshPackage();
        return hasActiveSubscription() || hasDailyLimit();
    }

    function showSubscriptionModal() {
        actionsMembership.open()
    }

    const authActions = {
        clearSession: clearSession,
        setSession: setSession,
        updateSession: updateSession,
        isUserAuthenticated: isUserAuthenticated,
        loadSession: loadSession,
        refreshPackage: refreshPackage,
        hasActiveSubscription: hasActiveSubscription,
        hasDailyLimit: hasDailyLimit,
        allowedToPractice: allowedToPractice,
        showSubscriptionModal: showSubscriptionModal,
        hasBook: hasBook,
        is_admin: is_admin,

    }

    useEffect(() => {
        if (session.token && last_fetched === null) refreshPackage();
    }, []);
    return {session, authActions, SESSION_STORAGE_KEY};
}

export function SessionWrapper({children}) {
    const {authActions} = useSession();
    const [isSessionLoaded, setIsSessionLoaded] = useState(false);
    useEffect(() => {
        authActions.loadSession().then(() => {
            setIsSessionLoaded(true);
        });

    }, []);
    if (!isSessionLoaded) return (<></>)
    return children;
}

export default AuthReducer;